import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Loading.css";
import { ExtractData } from "../ProposalForm/ExtractingData";
import { useToast } from "../../Componenets/Toast/Toast";
import { IconAlerta, IconRecarregar } from "../../Shared/Icons/Icons";
import Gabriel from "../../img/gabrielCorrendo.gif";

const INTERVALO_MS = 30;
// A barra espera em 90% ate a captura terminar, em vez de abrir o PDF sem dados.
const LIMITE_DURANTE_CAPTURA = 90;

const MENSAGEM_FALHA_AO_SALVAR =
  "Não foi possível salvar os dados do cliente. A proposta foi gerada normalmente.";

export default function Loading() {
  const navigate = useNavigate();
  const toast = useToast();
  const [progress, setProgress] = useState(0);
  // carregando | concluido | erro
  const [status, setStatus] = useState("carregando");
  const [erro, setErro] = useState(null);
  const [tentativa, setTentativa] = useState(0);

  useEffect(() => {
    const proposalLink = sessionStorage.getItem("proposalLink");
    const salvarDados = sessionStorage.getItem("salvarDados") !== "false";
    const prazoEntrega = sessionStorage.getItem("deliveryTime") || "";
    const canalEnvio = sessionStorage.getItem("canalEnvio") || "";
    let ativo = true;

    if (!proposalLink) {
      setErro({
        mensagem: "Nenhum link de proposta foi informado. Volte e cole o link do Tiny.",
        podeTentarDeNovo: false,
      });
      setStatus("erro");
      return undefined;
    }

    setStatus("carregando");
    setProgress(0);

    ExtractData(proposalLink, { salvarDados, prazoEntrega, canalEnvio })
      .then(({ dadosSalvos }) => {
        if (!ativo) return;

        // O toast fica no ToastProvider (fora das rotas) e continua visivel no PDF.
        if (salvarDados && dadosSalvos === true) {
          toast.sucesso("Dados do cliente salvos.");
        } else if (salvarDados && dadosSalvos === false) {
          toast.erro(MENSAGEM_FALHA_AO_SALVAR);
        }
        setStatus("concluido");
      })
      .catch(() => {
        if (!ativo) return;
        setErro({
          mensagem: "Verifique se o link do Tiny está correto e tente novamente.",
          podeTentarDeNovo: true,
        });
        setStatus("erro");
      });

    return () => {
      ativo = false;
    };
  }, [tentativa, toast]);

  useEffect(() => {
    if (status === "erro") return undefined;

    const limite = status === "concluido" ? 100 : LIMITE_DURANTE_CAPTURA;
    const interval = setInterval(() => {
      setProgress((prev) => Math.min(prev + 1, limite));
    }, INTERVALO_MS);
    return () => clearInterval(interval);
  }, [status]);

  useEffect(() => {
    if (status === "concluido" && progress >= 100) {
      navigate("/PDF-Proposta-Comercial", { replace: true });
    }
  }, [status, progress, navigate]);

  const tentarDeNovo = () => {
    setErro(null);
    setTentativa((atual) => atual + 1);
  };

  if (status === "erro") {
    return (
      <div className="loadingPage">
        <div className="card loading-error" role="alert">
          <span className="loading-error-icon">
            <IconAlerta size={28} />
          </span>
          <h1 className="loading-error-title">
            Não foi possível capturar a proposta
          </h1>
          <p className="loading-error-text">{erro?.mensagem}</p>
          <div className="loading-error-actions">
            {erro?.podeTentarDeNovo && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={tentarDeNovo}
              >
                <IconRecarregar size={18} />
                Tentar novamente
              </button>
            )}
            <Link to="/Proposta-Comercial" className="btn btn-secondary">
              Voltar para nova proposta
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="loadingPage">
      <h1 className="loading-title">
        Gabriel vem com uma proposta que até o banco sorriu💸💰
      </h1>
      <img
        className="loading-gif"
        src={Gabriel}
        alt="Gabriel correndo com a proposta"
      />
      <div
        className="progressContainer"
        role="progressbar"
        aria-label="Gerando a proposta"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <div className="progressBar" style={{ width: `${progress}%` }}></div>
      </div>
      <p className="progressText" aria-hidden="true">
        {progress}%
      </p>
      <p className="loading-status" role="status">
        {status === "concluido"
          ? "Proposta pronta! Abrindo o PDF…"
          : "Capturando os dados da proposta no Tiny…"}
      </p>
    </div>
  );
}
